function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPocSightseeingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4c-4.963 0-9 4.037-9 9 0 5.457 6.81 12.5 9 14.623C18.19 25.5 25 18.457 25 13c0-4.962-4.037-9-9-9zm0 26a1 1 0 01-.67-.258C14.91 29.363 5 20.36 5 13 5 6.935 9.935 2 16 2s11 4.936 11 11c0 7.36-9.91 16.363-10.331 16.744a1 1 0 01-.67.257zm0-14.904c-1.103 0-2-.897-2-2 0-1.104.897-2 2-2 1.104 0 2 .896 2 2 0 1.103-.896 2-2 2zM21.126 9.3H19.49L19.04 8a1.002 1.002 0 00-.944-.674h-4.194c-.426 0-.805.271-.945.673l-.45 1.301h-1.633a1 1 0 00-1 1v6.373a1 1 0 001 1h10.25a1 1 0 001-1V10.3a1 1 0 00-1-1z",
    fill: props.color
  }));
}

export default SvgIconPocSightseeingFilled;